// @flow
// Converted automatically using ./tools/themeFromVsCode

var theme = {
  "plain": {
    "backgroundColor": "#1b212c"
  },
  "styles": [
    {
      "types": [
        "comment"
      ],
      "style": {
        "color": "rgb(81, 103, 133)",
        "fontStyle": "italic"
      }
    },
    {
      "types": [
        "keyword",
        "selector",
        "changed"
      ],
      "style": {
        "color": "rgb(212, 159, 244)"
      }
    },
    {
      "types": [
        "operator"
      ],
      "style": {
        "color": "rgb(168, 181, 208)"
      }
    },
    {
      "types": [
        "constant",
        "number",
        "builtin",
        "attr-name"
      ],
      "style": {
        "color": "rgb(233, 182, 132)"
      }
    },
    {
      "types": [
        "char",
        "symbol"
      ],
      "style": {
        "color": "rgb(89, 242, 247)"
      }
    },
    {
      "types": [
        "variable",
        "tag",
        "deleted"
      ],
      "style": {
        "color": "rgb(229, 102, 116)"
      }
    },
    {
      "types": [
        "string",
        "inserted"
      ],
      "style": {
        "color": "rgb(112, 244, 156)"
      }
    },
    {
      "types": [
        "punctuation"
      ],
      "style": {
        "color": "rgb(81, 103, 133)"
      }
    },
    {
      "types": [
        "function"
      ],
      "style": {
        "color": "rgb(116, 179, 251)"
      }
    },
    {
      "types": [
        "class-name"
      ],
      "style": {
        "color": "rgb(229, 192, 123)"
      }
    }
  ]
};

export default theme;
